import { ComponentRef, Directive, Input, OnChanges, SimpleChanges, Type, ViewContainerRef, } from '@angular/core';
import { Column } from '@valg-shared/components/table/table/column';
import { Observable } from 'rxjs';
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { TextEllipsisTooltipRendererComponent } from '@valg-shared/components/table/renderers/text-ellipsis-tooltip-renderer/text-ellipsis-tooltip-renderer.component';

export interface CellRendererComponent<TRow = unknown, TValue = unknown> {
  value$?: Observable<TValue>;
  init?(data: TRow, column: Column): void;
}

@Directive({
  selector: '[valgCellOutlet]',
})
export class CellComponentOutletDirective implements OnChanges {
  @Input() valgCellComponentOutlet: Type<CellRendererComponent> = TextEllipsisTooltipRendererComponent;
  @Input() valgCellComponentOutletRow!: TableDataItem;
  @Input() valgCellComponentOutletColumn!: Column;

  private componentRef: ComponentRef<CellRendererComponent> | null = null;
  constructor(private readonly viewContainerRef: ViewContainerRef) {}

  public ngOnChanges(_changes: SimpleChanges): void {
    this.viewContainerRef.clear();
    this.componentRef = null;

    if (this.valgCellComponentOutlet) {
      const elInjector = this.viewContainerRef.injector;
      this.componentRef = this.viewContainerRef.createComponent(
          this.valgCellComponentOutlet,
          {
            index: this.viewContainerRef.length,
            injector: elInjector,
          }
      );

      if (this.componentRef.instance.init) {
        const column = { ... this.valgCellComponentOutletColumn };
        let row = { ... this.valgCellComponentOutletRow };
        column.path = row.children ? column.path : column.metadata?.childPath ?? column.path
        this.componentRef.instance.init(row, column);
      }
    }
  }
}
